import { createSlice } from '@reduxjs/toolkit';

const initialValues = {};

const absSlice = createSlice({
  name: 'abs',
  initialState: {
    absData: initialValues,
    hasAbsData: false,
  },
  reducers: {
    setSavedAbsData: (state, action) => {
      state.absData = action.payload;
      state.hasAbsData = Boolean(Object.keys(action.payload).length);
    },
    clearAbsData: (state) => {
      state.absData = initialValues;
      state.hasAbsData = false;
    },
  },
});

export const { setSavedAbsData, clearAbsData } = absSlice.actions;
export default absSlice.reducer;